export default "__VITE_ASSET__3ae24475__"